import type { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { domainClasses, type Domain } from "./domains";

const TILT: Record<number, string> = {
  [-4]: "-rotate-[4deg]",
  [-3]: "-rotate-3",
  [-2]: "-rotate-2",
  [-1]: "-rotate-1",
  0: "",
  1: "rotate-1",
  2: "rotate-2",
  3: "rotate-3",
  4: "rotate-[4deg]",
};

export interface HandNoteProps {
  children: ReactNode;
  tilt?: -4 | -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4;
  tone?: "action" | "inverse" | Domain;
  size?: "md" | "lg";
  /** Set when the note repeats nearby text. */
  decorative?: boolean;
  className?: string;
}

/**
 * Caveat margin note. Website only (never dashboard, reports or email). About
 * eight words; never numbers, instructions, form labels or legal text. At most
 * one per card and two per viewport.
 */
export function HandNote({
  children,
  tilt = -2,
  tone = "action",
  size = "md",
  decorative = false,
  className,
}: HandNoteProps) {
  return (
    <span
      aria-hidden={decorative || undefined}
      className={cn(
        "inline-block font-hand font-medium leading-tight",
        size === "md" ? "text-[22px]" : "text-[30px]",
        TILT[tilt],
        tone === "action"
          ? "text-caire-action"
          : tone === "inverse"
            ? "text-caire-accent-soft"
            : domainClasses[tone].ink,
        className,
      )}
    >
      {children}
    </span>
  );
}
